import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faSquareCheck } from "@fortawesome/pro-regular-svg-icons";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Wraps a record card with a selectable checkbox on the left. */
export function CheckboxWrapper(_ref) {
  var id = _ref.id,
    isSelected = _ref.isSelected,
    onToggle = _ref.onToggle,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex rounded-sds-300 gap-2 ".concat(isSelected ? "bg-sds-brand-tertiary" : "bg-sds-base-secondary")
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "link-records-checkbox-".concat(id),
    "aria-label": isSelected ? t("label.deselect_record", {
      defaultValue: "Deselect record"
    }) : t("label.select_record", {
      defaultValue: "Select record"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LINK_RECORDS_CHECKBOX, {
        recordId: id
      });
      onToggle(id);
    },
    className: "pl-2 mt-2 mb-auto cursor-pointer text-sds-base-secondary hover:text-sds-base-default transition-colors"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: isSelected ? faSquareCheck : faSquare,
    className: "w-3.5 h-3.5 ".concat(isSelected ? "text-sds-brand-default" : "")
  })), children);
}